/**
 * 必填验证规则
 */
export const getRequiredRule = (title: string, isSelect = false) => ({ required: true, message: `请${isSelect ? '选择' : '输入'}${title}` })
/**
 * 房号格式验证规则
 * 1-1、1-1-1、1-1-1-1等格式，且每一部分不能以0开头
 */
export const ROOM_NO_REG = /^[1-9]\d*(?:-[1-9]\d*){1,3}$/
/**
 * 房号格式帮助提示
 */
export const ROOM_NO_HELP = '房号格式示例：1-1、1-1-1、1-1-1-1，每一部分不能以0开头'
